import gql from "graphql-tag";

export default gql`query UnrepliedMessages($first:Int!, $pagesize:Int!, $sortby:String, $descending:Boolean) {
    unrepliedMessages(first:$first, pagesize:$pagesize, sortby:$sortby, descending:$descending) {
        id    
        body
        timestamp
        file {
            id
            referencelong
            department {
                id                
            }
        }
        user {
            id
            name
        }
      }
  }`